export default __webpack_public_path__ + "static/media/whiteHolder.086c5436.jpg";